<template>
  <div>
    <img src="/assets/homePage/Path.png" class="fixed-left" style="top: 300px; pointer-events: none;" alt="" role="presentation"/>
    <BannerComponent />
    <FeatureBaner />
    <FreeTrial />
    <ExploreBanner />
    <!--<TestimonialComponent />-->
    <PricePlan />
    <QuestionsBanner />
  </div>
</template>

<script setup>
import BannerComponent from "components/homePage/Banner.vue";
import FeatureBaner from "components/homePage/FeatureBaner.vue";
import FreeTrial from "components/homePage/Philosophy.vue";
import ExploreBanner from "components/homePage/ExploreBanner.vue";
import TestimonialComponent from "components/homePage/TestimonialComponent.vue";
import PricePlan from "components/homePage/PricePlan.vue";
import QuestionsBanner from "components/homePage/QuestionsBanner.vue";
import FooterComponent from "components/Footer.vue";
defineOptions({
  name: "IndexPage",
});

</script>
<style lang="scss">
.component-header {
  padding: 20px 0;
}

.component-header .paragraph {
  font-size: 20px;
  line-height: 36px;
  font-weight: 400;
  color: $grey-7;
  width: 66%;
  margin: 0 auto;
}
</style>
